import React from "react";
import { Link } from "react-router-dom"

interface CategoryTagsProps {
    label?: string,
    categoryNames: string[],
    categoryIds: string[]
    separator?: string
    storageId: string
}

const CategoryTags: React.FC<CategoryTagsProps> = ({ label, categoryNames, categoryIds, separator = ">", storageId }) => {

    if (categoryNames.length === 0 || categoryIds.length === 0) {
        return null
    }

    return (
        <div className="flex flex-wrap gap-2">
            {label && <b>{label}:</b>}
            {/* Map through category names and doc IDs to create links */}
            {categoryNames.map((categoryName, i) => {
                const categoryId = categoryIds[i];
                if (categoryName && categoryId) {
                    return (
                        <React.Fragment key={categoryId}>
                            <Link to={`/storage/categories/${categoryId}`} className="link">{categoryName}</Link>
                            {i < categoryNames.length - 1 && separator}
                        </React.Fragment>
                    );
                }
                return null;
            })}
        </div>
    );
}

export default CategoryTags

